jQuery(document).ready(function($) {    
	//FAQ on click hide/show animation
  	$(".faq_section").click(function () {
		$(this).toggleClass('active');
  	});
  });